import { Chip, Tooltip } from "@mui/material";
import { formatDate } from "../../../helpers/formatingFunctions";
import UpdateOrientationPopup from "../../../components/Recruiting/OrientationSchedule/UpdateOrientationPopup";
import { camelCaseToSentenceCase } from "../../../helpers/camelCaseToSentenceCase";

export const orientationScheduleTableColumns = [
  {
    field: "orientationDate",
    headerName: "Orientation Date",
    width: 160,
    valueFormatter: (value: string) => (value ? formatDate(value) : ""),
  },
  {
    field: "driverName",
    headerName: "Driver",
    width: 180,
    valueGetter: (value: string, row: any) =>
      `${row.driverFirstName ?? ""} ${row.driverLastName ?? ""}`.trim(),
  },
  { field: "company", headerName: "Company", width: 160 },
  {
    field: "status",
    headerName: "Status",
    width: 140,
    renderCell: (params: any) => {
      const rawStatus = params?.value ?? params?.row?.status;
      const status = String(rawStatus ?? "").trim();

      const normalized = status.toLowerCase();
      const color =
        normalized === "hired"
          ? "success"
          : normalized === "declined"
            ? "error"
            : normalized === "scheduled"
              ? "info"
              : normalized === "no_show"
                ? "warning"
                : "default";

      const labelMap: Record<string, string> = {
        hired: "Hired",
        declined: "Declined",
        no_show: "No Show",
        scheduled: "Scheduled",
      };

      return (
        <Tooltip title={params.row.note || ""} arrow>
          <Chip
            size="small"
            label={labelMap[normalized] || ""}
            color={color}
            variant={color === "default" ? "outlined" : "filled"}
          />
        </Tooltip>
      );
    },
  },
  { field: "referral", headerName: "Referral", width: 160 },
  {
    field: "driverHireType",
    headerName: "Driver Hire Type",
    width: 180,
    renderCell: (params: any) => {
      const rawHireType = params?.value ?? params?.row?.driverHireType;
      const hireType = String(rawHireType ?? "").trim();
      const normalized = hireType.toLowerCase();

      const labelMap: Record<string, string> = {
        new_hire: "New hire",
        "re-hire": "Re-hire",
        switch: "Switch",
        back_from_vacation: "Back from vacation",
      };

      const color =
        normalized === "new_hire"
          ? "info"
          : normalized === "re-hire"
            ? "secondary"
            : normalized === "switch"
              ? "warning"
              : normalized === "back_from_vacation"
                ? "success"
                : "default";

      return (
        <Chip
          size="small"
          label={labelMap[normalized] ?? hireType}
          color={color}
          variant={color === "default" ? "outlined" : "filled"}
        />
      );
    },
  },

  { field: "recruiter", headerName: "Recruiter", width: 160 },
  { field: "division", headerName: "Division", width: 140 },
  { field: "state", headerName: "State", width: 100 },
  {
    field: "primaryPhoneNumber",
    headerName: "Phone",
    width: 150,
  },
  { field: "email", headerName: "Email", width: 220 },
  {
    field: "trailerType",
    headerName: "Trailer Type",
    width: 140,
    valueFormatter: (value: string) => camelCaseToSentenceCase(value) || "",
  },
  { field: "truckUnitNumber", headerName: "Truck Unit", width: 130 },
  { field: "trailerUnitNumber", headerName: "Trailer Unit", width: 130 },
  { field: "pay", headerName: "Pay", width: 120 },
  {
    field: "update",
    headerName: "",
    width: 140,
    renderCell: (params: any) => (
      <UpdateOrientationPopup orientation={params.row} />
    ),
  },
  // },
  // {
  //   field: "delete",
  //   headerName: "",
  //   width: 140,
  //   renderCell: (params: any) => (
  //     <RecruitingDeleteButton
  //       id={params.row.id}
  //       endpoint="recruiting/orientation"
  //       entityLabel="orientation"
  //       queryKey={["orientations"]}
  //     />
  //   ),
  // },
];
